import rawDataTabRedux from 'Modules/rawData/.components/tab/redux/reducer';
import showRawDataRedux from 'Modules/rawData/.components/showRawData/redux/reducer';
import deviceReadingRedux from 'Modules/rawData/.components/tab/.components/details/redux/reducer';
import videoPlayerRedux from 'Modules/rawData/.components/videoPlayer/redux/reducer';

//export redux objects
export default {
	rawDataTabRedux,
	showRawDataRedux,
	deviceReadingRedux,
	videoPlayerRedux,
};